(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 75511:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(98374);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./src/imports/LanguageSelect/index.js + 1 modules
var LanguageSelect = __webpack_require__(99612);
// EXTERNAL MODULE: ./src/assets/icons/register-drawings.svg
var register_drawings = __webpack_require__(39880);
// EXTERNAL MODULE: ./src/assets/icons/register-drawings-small.svg
var register_drawings_small = __webpack_require__(55802);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/getLocalizedImage.js
var getLocalizedImage = __webpack_require__(42641);
// EXTERNAL MODULE: ./src/components/ResponsiveButton/index.js + 1 modules
var ResponsiveButton = __webpack_require__(97037);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(21987);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
// EXTERNAL MODULE: ./src/assets/logo.png
var logo = __webpack_require__(18630);
// EXTERNAL MODULE: ./src/assets/logo-small.png
var logo_small = __webpack_require__(93347);
;// CONCATENATED MODULE: ./src/sections/register/components/CreateAccountLayout.js








function CreateAccountLayout(param) {
    let { children , title , subtitle  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "register"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: 4,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                sx: {
                    borderRadius: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    py: {
                        xs: 4,
                        md: 5
                    },
                    px: {
                        xs: 3,
                        md: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            sx: {
                                                fontSize: {
                                                    xs: "25px !important",
                                                    md: "40px !important"
                                                },
                                                mb: 2
                                            },
                                            textTransform: "capitalize",
                                            children: title || t("register:create_your_account")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            color: "neutral.dark",
                                            fontWeight: 400,
                                            children: subtitle || t("register:Get_started_in_just_3_simple_steps")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            width: 150,
                                            sx: {
                                                display: {
                                                    xs: "none",
                                                    sm: "block"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                href: "/",
                                                "aria-label": "home page",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    style: {
                                                        width: "100%",
                                                        height: "auto",
                                                        objectFit: "contain"
                                                    },
                                                    alt: t("common:blue_assembly_logo"),
                                                    src: logo/* default */.Z
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            width: 25,
                                            sx: {
                                                display: {
                                                    xs: "block",
                                                    sm: "none"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                href: "/",
                                                "aria-label": t("common:home_page"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    style: {
                                                        width: "100%",
                                                        height: "auto",
                                                        objectFit: "contain"
                                                    },
                                                    alt: t("common:blue_assembly_logo"),
                                                    src: logo_small/* default */.Z
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 2,
                            children: children
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var components_CreateAccountLayout = (CreateAccountLayout);

;// CONCATENATED MODULE: ./src/sections/register/components/InstructionsSection.js








const instructions = [
    {
        title: "register",
        subtitle: "Sign_up_and_tell_us_more_about_your_school",
        image: "register-build.png"
    },
    {
        title: "set_up_your_dashboard",
        subtitle: "Manage_registrations,_waiting_lists",
        image: "register-dashboard.png"
    },
    {
        title: "start_use_the_mobile_app",
        subtitle: "Imagine_how_happy_parents_will_be_by_being_engaged",
        image: "register-mobile.png"
    }
];
function InstructionsSection(param) {
    let { handleSkip  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [active, setActive] = react.useState(0);
    const handleNext = ()=>{
        if (active < instructions.length - 1) setActive(active + 1);
        else handleSkip();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateAccountLayout, {
        children: instructions.map((param, index)=>/*#__PURE__*/ {
            let { title , subtitle , image  } = param;
            return (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: active === index,
                sx: {
                    display: active === index ? "" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    maxHeight: 350,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    priority: index === 0,
                                    style: {
                                        maxWidth: "100%",
                                        maxHeight: 350,
                                        objectFit: "contain"
                                    },
                                    src: (0,getLocalizedImage/* default */.Z)(image),
                                    alt: "".concat(t("register:instructions.".concat(title)), " image"),
                                    width: 1000,
                                    height: 350
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    textAlign: "center",
                                    variant: "h5",
                                    fontWeight: 700,
                                    sx: {
                                        mb: 3
                                    },
                                    display: "block",
                                    children: [
                                        index + 1,
                                        ". ",
                                        t("register:instructions.".concat(title))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    textAlign: "center",
                                    variant: "body1",
                                    fontWeight: 400,
                                    color: "neutral.dark",
                                    display: "block",
                                    children: t("register:instructions.".concat(subtitle))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 2,
                                justifyContent: "center",
                                children: instructions.map((a, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                backgroundColor: idx === active ? "primary.main" : "#9E9E9E80",
                                                borderRadius: "10px",
                                                width: 30,
                                                height: 10
                                            }
                                        })
                                    }, idx))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 2,
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                            id: "instructions-skip-button",
                                            color: "neutral",
                                            sx: {
                                                color: "neutral.dark"
                                            },
                                            onClick: handleSkip,
                                            "aria-label": t("common:skip"),
                                            children: t("common:skip")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                            variant: "contained",
                                            sx: {
                                                minWidth: 125
                                            },
                                            onClick: handleNext,
                                            disableElevation: true,
                                            "aria-label": t("common:next"),
                                            children: t("common:next")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }, index);
        })
    });
}
/* harmony default export */ var components_InstructionsSection = (InstructionsSection);

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(91057);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(22715);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js
var FormControl = __webpack_require__(53640);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(20847);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(58128);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(37786);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(74509);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Business.js
var Business = __webpack_require__(52046);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/EmailOutlined.js
var EmailOutlined = __webpack_require__(73479);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/LockOutlined.js
var LockOutlined = __webpack_require__(30038);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/components/FlatTextField/index.js + 1 modules
var FlatTextField = __webpack_require__(35133);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/VisibilityOff.js
var VisibilityOff = __webpack_require__(58883);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Visibility.js
var Visibility = __webpack_require__(52186);
;// CONCATENATED MODULE: ./src/imports/PasswordTextField/PasswordTextField.js





function PasswordTextField(param) {
    let { InputProps ={} , size ="medium" , ...props } = param;
    const [showPassword, setShowPassword] = react.useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
        InputProps: {
            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    "aria-label": "toggle password visibility",
                    onClick: ()=>setShowPassword(!showPassword),
                    size: size,
                    children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {
                        fontSize: size
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {
                        fontSize: size
                    })
                })
            }),
            ...InputProps
        },
        size: size,
        ...props,
        type: showPassword ? "text" : "password"
    });
}
/* harmony default export */ var PasswordTextField_PasswordTextField = (PasswordTextField);

;// CONCATENATED MODULE: ./src/imports/PasswordTextField/index.js


/* harmony default export */ var imports_PasswordTextField = (PasswordTextField_PasswordTextField);

// EXTERNAL MODULE: ./src/components/FlatButton/index.js + 1 modules
var FlatButton = __webpack_require__(54075);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/api/httpClient.js + 4 modules
var httpClient = __webpack_require__(16799);
;// CONCATENATED MODULE: ./src/api/auth.js


const useRegister = ()=>(0,useMutation/* useMutation */.D)((payload)=>httpClient/* httpClient.post */.M.post("/auth/register", payload));

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/react-lottie-player/dist/LottiePlayer.modern.js
var LottiePlayer_modern = __webpack_require__(69185);
;// CONCATENATED MODULE: ./src/sections/register/components/lottie.json
var lottie_namespaceObject = JSON.parse('{"v":"5.7.4","fr":24,"ip":121,"op":169,"w":1080,"h":1080,"nm":"ric-2033-bouncing","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":2,"ty":4,"nm":"splash","sr":1,"ks":{"o":{"a":1,"k":[{"t":118.4,"s":[0],"h":1},{"t":121.6,"s":[100],"h":1},{"t":128,"s":[0],"h":1},{"t":134.400390625,"s":[100],"h":1}],"ix":11,"x":"var $bm_rt;\\n$bm_rt = loopOut();"},"r":{"a":0,"k":8,"ix":10},"p":{"a":0,"k":[540,715,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-20,100],[-102.839,100]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.25,0.25,0.25,1],"ix":3,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Shape Layer 1\').content(\'Rectangle 1\').content(\'Fill 1\').color;"},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[-20,100],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"rp","c":{"a":1,"k":[{"t":118.4,"s":[3],"h":1},{"t":134.4,"s":[2],"h":1},{"t":150.4,"s":[1],"h":1},{"t":166.4,"s":[3],"h":1},{"t":198.400390625,"s":[3],"h":1}],"ix":1,"x":"var $bm_rt;\\n$bm_rt = loopOut();"},"o":{"a":0,"k":0,"ix":2},"m":1,"ix":2,"tr":{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":1,"k":[{"t":118.4,"s":[28],"h":1},{"t":134.4,"s":[54],"h":1},{"t":150.400390625,"s":[28],"h":1}],"ix":4},"so":{"a":0,"k":100,"ix":5},"eo":{"a":0,"k":100,"ix":6},"nm":"Transform"},"nm":"Repeater 1","mn":"ADBE Vector Filter - Repeater","hd":false},{"ty":"rp","c":{"a":0,"k":2,"ix":1},"o":{"a":0,"k":0,"ix":2},"m":1,"ix":3,"tr":{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":1,"k":[{"t":118.4,"s":[107],"h":1},{"t":134.4,"s":[115],"h":1},{"t":150.4,"s":[149],"h":1},{"t":166.4,"s":[107],"h":1},{"t":198.400390625,"s":[107],"h":1}],"ix":4,"x":"var $bm_rt;\\n$bm_rt = loopOut();"},"so":{"a":0,"k":100,"ix":5},"eo":{"a":0,"k":100,"ix":6},"nm":"Transform"},"nm":"Repeater 2","mn":"ADBE Vector Filter - Repeater","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.29],"y":[1]},"o":{"x":[0.167],"y":[0.141]},"t":118.4,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":127.2,"s":[100]},{"t":134.400390625,"s":[100]}],"ix":1,"x":"var $bm_rt;\\n$bm_rt = loopOut();"},"e":{"a":1,"k":[{"i":{"x":[0.29],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":118.4,"s":[0]},{"i":{"x":[0.29],"y":[1]},"o":{"x":[0.167],"y":[0.141]},"t":120,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":128.8,"s":[100]},{"t":134.400390625,"s":[100]}],"ix":2,"x":"var $bm_rt;\\n$bm_rt = loopOut();"},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":4,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":1329,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"floor","parent":5,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[49.917,70,0],"ix":2,"l":2},"a":{"a":0,"k":[-0.25,60,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0,0,0],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":120,"s":[27,33.333,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[1,1,1],"y":[0,0,0]},"t":128,"s":[33.333,33.333,100]},{"t":136,"s":[27,33.333,100]}],"ix":6,"x":"var $bm_rt;\\n$bm_rt = loopOut();","l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-300.5,60],[300,60]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.3,0.3,0.3,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"d":[{"n":"d","nm":"dash","v":{"a":0,"k":696,"ix":1}},{"n":"g","nm":"gap","v":{"a":0,"k":10,"ix":2}},{"n":"o","nm":"offset","v":{"a":0,"k":-549,"ix":7}}],"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1329,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":3,"nm":"Scale","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[540,660,0],"ix":2,"l":2},"a":{"a":0,"k":[50,50,0],"ix":1,"l":2},"s":{"a":0,"k":[300,300,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":1329,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 1","parent":5,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":104,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":112,"s":[90]},{"t":120,"s":[180]}],"ix":10,"x":"var $bm_rt;\\n$bm_rt = loopOut(\'offset\');"},"p":{"s":true,"x":{"a":0,"k":50,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":120,"s":[55.333]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":128,"s":[-50]},{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":136,"s":[55.333]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":144,"s":[-50]},{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":152,"s":[55.333]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":160,"s":[-50]},{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":168,"s":[55.333]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":176,"s":[-50]},{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":184,"s":[55.333]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":192,"s":[-50]},{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":200,"s":[61.5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":208,"s":[-50]},{"t":216,"s":[55.333]}],"ix":4,"x":"var $bm_rt;\\n$bm_rt = loopOut();"}},"a":{"a":0,"k":[18,-57,0],"ix":1,"l":2},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":120,"s":[110,75,100]},{"i":{"x":[0,0,0],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0]},"t":121.6,"s":[75,110,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,1]},"o":{"x":[1,1,1],"y":[0,0,0]},"t":128,"s":[100,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":133.6,"s":[75,110,100]},{"t":136,"s":[110,75,100]}],"ix":6,"x":"var $bm_rt;\\n$bm_rt = loopOut();","l":2}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":120,"s":[8]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"t":128,"s":[15]},{"t":136,"s":[8]}],"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":120,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[20,-20],[20,0],[20,20],[0,20],[-20,20],[-20,-20]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":128,"s":[{"i":[[-11.046,0],[-3.619,-3.619],[0,-5.523],[3.619,-3.619],[5.523,0],[0,11.046]],"o":[[5.523,0],[3.619,3.619],[0,5.523],[-3.619,3.619],[-11.046,0],[0,-11.046]],"v":[[0,-20],[14.142,-14.142],[20,0],[14.142,14.142],[0,20],[-20,0]],"c":true}]},{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":136,"s":[{"i":[[-11.046,0],[-3.619,-3.619],[0,-5.523],[3.619,-3.619],[5.523,0],[0,11.046]],"o":[[5.523,0],[3.619,3.619],[0,5.523],[-3.619,3.619],[-11.046,0],[0,-11.046]],"v":[[0,-20],[14.142,-14.142],[20,0],[14.142,14.142],[0,20],[-20,0]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":144,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,-20],[8.66,-5],[17.321,10],[0,10],[-17.321,10],[-8.66,-5]],"c":true}]},{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"t":152,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,-20],[8.66,-5],[17.321,10],[0,10],[-17.321,10],[-8.66,-5]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":160,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[20,-20],[20,0],[20,20],[0,20],[-20,20],[-20,-20]],"c":true}]},{"t":168,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[20,-20],[20,0],[20,20],[0,20],[-20,20],[-20,-20]],"c":true}]}],"ix":2,"x":"var $bm_rt;\\nvar pingPong, timeStart, duration, quant, quant, t, t, t;\\npingPong = false;\\ntry {\\n    timeStart = thisProperty.key(1).time;\\n    duration = $bm_sub(thisProperty.key(thisProperty.numKeys).time, timeStart);\\n    quant = Math.floor($bm_div($bm_sub(time, timeStart), duration));\\n    if (quant < 0)\\n        quant = 0;\\n    if (quant % 2 == 1 && pingPong == true) {\\n        t = $bm_sub($bm_sum($bm_mul(2, timeStart), $bm_mul($bm_sum(quant, 1), duration)), time);\\n    } else {\\n        t = $bm_sub(time, $bm_mul(quant, duration));\\n    }\\n} catch (e) {\\n    t = time;\\n}\\n$bm_rt = thisProperty.valueAtTime(t);"},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.25,0.25,0.25,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":1,"k":[{"t":120.8,"s":[1,0.200000017881,0.400000035763,1],"h":1},{"t":136.8,"s":[0.313725501299,0.823529481888,0.760784387589,1],"h":1},{"t":152.8,"s":[0.203921586275,0.596078455448,0.858823597431,1],"h":1},{"t":168.7998046875,"s":[1,0.200000017881,0.400000035763,1],"h":1}],"ix":4,"x":"var $bm_rt;\\n$bm_rt = loopOut();"},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[18,-57],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1329,"st":0,"bm":0}],"markers":[]}');
;// CONCATENATED MODULE: ./src/sections/register/components/Loader.js






function Loader(param) {
    let { active  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "register"
    ]);
    const [current, setCurrent] = react.useState(0);
    const loadingTexts = [
        t("register:This_may_take_a_bit_of_time"),
        t("register:Preparing_your_institution_data"),
        t("register:Building_your_domain")
    ];
    react.useEffect(()=>{
        setCurrent(()=>0);
        let timer;
        if (active) timer = setInterval(()=>setCurrent((prev)=>(prev + 1) % loadingTexts.length), 5000);
        else if (timer) clearInterval(timer);
        return ()=>timer && clearInterval(timer);
    }, [
        active
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            height: "75vh",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LottiePlayer_modern/* default */.Z, {
                    loop: true,
                    animationData: lottie_namespaceObject,
                    play: true,
                    style: {
                        width: "100%",
                        height: 300
                    }
                }),
                loadingTexts.map((text, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                        in: current === index,
                        sx: {
                            display: current === index ? "" : "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            color: "primary.main",
                            align: "center",
                            children: text
                        })
                    }, index))
            ]
        })
    });
}
/* harmony default export */ var components_Loader = (Loader);

;// CONCATENATED MODULE: ./src/sections/register/components/CreateAccountSection.js

















const validationSchema = es/* object */.Ry().shape({
    domain: es/* string */.Z_().subdomain().required(),
    email: es/* string */.Z_().email().required(),
    password: es/* string */.Z_().min(6).required(),
    terms: es/* boolean */.O7().required().oneOf([
        true
    ], "The terms and conditions must be accepted.")
});
function CreateAccountSection(param) {
    let { handleNext , setData  } = param;
    const { t , i18n  } = (0,esm/* useTranslation */.$G)();
    const direction = i18n.dir(i18n.language);
    const registerMutation = useRegister();
    const { executeRecaptcha  } = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)();
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            domain: "",
            email: "",
            password: "",
            terms: false
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values, actions)=>{
            if (executeRecaptcha) executeRecaptcha("").then((captchaToken)=>{
                registerMutation.mutateAsync({
                    ...values,
                    "g-recaptcha-response": captchaToken
                }).then((res)=>{
                    setData((prevData)=>({
                            ...prevData,
                            token: res.data.data.access_token,
                            domain: ( false ? 0 : "") + values.domain,
                            account_creation_time: moment_default()()
                        }));
                    handleNext();
                }).catch((err)=>{
                    if (err.response) {
                        var _err_response, _err_response_data, _err_response_data_data, _err_response_data_data_errors;
                        (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : (_err_response_data_data = _err_response_data.data) === null || _err_response_data_data === void 0 ? void 0 : (_err_response_data_data_errors = _err_response_data_data.errors) === null || _err_response_data_data_errors === void 0 ? void 0 : _err_response_data_data_errors.map((error)=>react_toastify_esm/* toast.error */.Am.error(error));
                    } else react_toastify_esm/* toast.error */.Am.error("unknown error");
                }).finally(()=>actions.setSubmitting(false));
            }).catch(()=>{
                react_toastify_esm/* toast.error */.Am.error("Failed to generate token");
                actions.setSubmitting(false);
            });
            else {
                react_toastify_esm/* toast.error */.Am.error("Failed to generate token");
                actions.setSubmitting(false);
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: !formik.isSubmitting,
                sx: {
                    display: !formik.isSubmitting ? "" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateAccountLayout, {
                        subtitle: t("register:Sign_up_with_your_email"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 5,
                                component: "form",
                                onSubmit: formik.handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                                            name: "domain",
                                            value: formik.values.domain,
                                            onChange: formik.handleChange,
                                            onBlur: formik.handleBlur,
                                            error: formik.touched.domain && Boolean(formik.errors.domain),
                                            helperText: formik.touched.domain && formik.errors.domain,
                                            fullWidth: true,
                                            label: t("common:Institution_name"),
                                            backgroundColor: "neutral.main",
                                            size: "large",
                                            StartIcon: Business/* default */.Z,
                                            inputProps: {
                                                "aria-label": t("common:Institution_name")
                                            },
                                            // eslint-disable-next-line react/jsx-no-duplicate-props
                                            InputProps: {
                                                style: {
                                                    direction: "ltr"
                                                },
                                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                                    position: direction === "rtl" ? "start" : "end",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        size: "large",
                                                        select: true,
                                                        inputProps: {
                                                            sx: {
                                                                fontSize: {
                                                                    xs: 13,
                                                                    md: "inherit"
                                                                }
                                                            },
                                                            "aria-label": t("common:Domain")
                                                        },
                                                        sx: {
                                                            width: {
                                                                xs: 125,
                                                                sm: 225,
                                                                md: 200,
                                                                lg: 250
                                                            },
                                                            border: 1,
                                                            ml: direction === "rtl" ? -1.75 : 0,
                                                            mr: direction === "ltr" ? -1.75 : 0,
                                                            borderTopLeftRadius: direction === "rtl" ? 8 : 0,
                                                            borderBottomLeftRadius: direction === "rtl" ? 8 : 0,
                                                            borderTopRightRadius: direction === "ltr" ? 8 : 0,
                                                            borderBottomRightRadius: direction === "ltr" ? 8 : 0,
                                                            borderColor: "primary.main"
                                                        },
                                                        defaultValue: "blueassembly",
                                                        children: [
                                                            {
                                                                value: "blueassembly",
                                                                label: ".blueassembly.com"
                                                            }
                                                        ].map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                                value: option.value,
                                                                style: {
                                                                    direction: "ltr"
                                                                },
                                                                children: option.label
                                                            }, option.value))
                                                    })
                                                })
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                                            name: "email",
                                            value: formik.values.email,
                                            onChange: formik.handleChange,
                                            onBlur: formik.handleBlur,
                                            error: formik.touched.email && Boolean(formik.errors.email),
                                            helperText: formik.touched.email && formik.errors.email,
                                            fullWidth: true,
                                            label: t("common:Email"),
                                            type: "email",
                                            backgroundColor: "neutral.main",
                                            size: "large",
                                            StartIcon: EmailOutlined/* default */.Z,
                                            inputProps: {
                                                "aria-label": t("common:Email")
                                            },
                                            // eslint-disable-next-line react/jsx-no-duplicate-props
                                            InputProps: {
                                                style: {
                                                    direction: "ltr"
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(imports_PasswordTextField, {
                                                name: "password",
                                                value: formik.values.password,
                                                onChange: formik.handleChange,
                                                onBlur: formik.handleBlur,
                                                error: formik.touched.password && Boolean(formik.errors.password),
                                                helperText: formik.touched.password && formik.errors.password,
                                                fullWidth: true,
                                                label: t("common:Password"),
                                                backgroundColor: "neutral.main",
                                                size: "large",
                                                StartIcon: LockOutlined/* default */.Z,
                                                inputProps: {
                                                    "aria-label": t("common:Password")
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                sx: {
                                                    mt: 1
                                                },
                                                component: "fieldset",
                                                variant: "standard",
                                                error: formik.touched.terms && Boolean(formik.errors.terms),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            checked: formik.values.terms,
                                                            onChange: (event)=>formik.setFieldValue("terms", event.target.checked),
                                                            name: "terms"
                                                        }),
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            fontWeight: 400,
                                                            sx: {
                                                                fontSize: {
                                                                    xs: 14,
                                                                    md: "inherit"
                                                                }
                                                            },
                                                            textTransform: "capitalize",
                                                            children: [
                                                                t("register:accept_our"),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                    href: "/terms-and-conditions",
                                                                    target: "_blank",
                                                                    "aria-label": t("register:terms_&_conditions"),
                                                                    children: t("register:terms_&_conditions")
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        children: formik.touched.terms && formik.errors.terms
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatButton/* default */.Z, {
                                                id: "create-account-button",
                                                variant: "contained",
                                                sx: {
                                                    mb: 2
                                                },
                                                onClick: formik.handleSubmit,
                                                "aria-label": t("register:create_account"),
                                                type: "submit",
                                                isLoading: formik.isSubmitting,
                                                children: t("register:create_account")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                fontWeight: 400,
                                                color: "neutral.dark",
                                                sx: {
                                                    fontSize: {
                                                        xs: 14,
                                                        md: "inherit"
                                                    }
                                                },
                                                display: "block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
                                                    href: "/login",
                                                    children: [
                                                        t("register:Already_have_an_account"),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            component: "span",
                                                            fontWeight: 600,
                                                            color: "#000",
                                                            fontSize: "inherit",
                                                            children: t("common:login")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: formik.isSubmitting,
                sx: {
                    display: formik.isSubmitting ? "" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader, {
                        active: formik.isSubmitting
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var components_CreateAccountSection = (CreateAccountSection);

// EXTERNAL MODULE: ./node_modules/@mui/material/Stepper/Stepper.js
var Stepper = __webpack_require__(10789);
// EXTERNAL MODULE: ./node_modules/@mui/material/Step/Step.js
var Step = __webpack_require__(74791);
// EXTERNAL MODULE: ./node_modules/@mui/material/StepLabel/StepLabel.js
var StepLabel = __webpack_require__(80003);
// EXTERNAL MODULE: ./src/api/common.js
var common = __webpack_require__(90176);
;// CONCATENATED MODULE: ./src/sections/register/components/InfoStep1.js









const InfoStep1_validationSchema = es/* object */.Ry().shape({
    institution_name: es/* string */.Z_().required("Field is required"),
    student_count: es/* string */.Z_().required("Field is required")
});
function InfoStep1(param) {
    let { data , setData , handleNext  } = param;
    var _schoolInfoQuery_data;
    const { t , i18n  } = (0,esm/* useTranslation */.$G)([
        "common",
        "register"
    ]);
    var _data_for_client, _data_institution_name, _data_student_count;
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            for_client: (_data_for_client = data === null || data === void 0 ? void 0 : data.for_client) !== null && _data_for_client !== void 0 ? _data_for_client : false,
            institution_name: (_data_institution_name = data === null || data === void 0 ? void 0 : data.institution_name) !== null && _data_institution_name !== void 0 ? _data_institution_name : "",
            student_count: (_data_student_count = data === null || data === void 0 ? void 0 : data.student_count) !== null && _data_student_count !== void 0 ? _data_student_count : ""
        },
        validationSchema: InfoStep1_validationSchema,
        enableReinitialize: true,
        onSubmit: (values, actions)=>{
            setData((prevData)=>({
                    ...prevData,
                    ...values
                }));
            handleNext();
            actions.setSubmitting(false);
        }
    });
    const schoolInfoQuery = (0,common/* useSchoolInfo */.Kh)(data.domain, data.token, i18n.language);
    var _schoolInfoQuery_data_student_count;
    const studentCounts = (_schoolInfoQuery_data_student_count = schoolInfoQuery === null || schoolInfoQuery === void 0 ? void 0 : (_schoolInfoQuery_data = schoolInfoQuery.data) === null || _schoolInfoQuery_data === void 0 ? void 0 : _schoolInfoQuery_data.student_count) !== null && _schoolInfoQuery_data_student_count !== void 0 ? _schoolInfoQuery_data_student_count : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
            xs: 2,
            md: 5
        },
        onSubmit: formik.handleSubmit,
        component: "form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                    fullWidth: true,
                    label: t("register:form.What_is_your_institution_name"),
                    backgroundColor: "neutral.main",
                    size: "large",
                    name: "institution_name",
                    value: formik.values.institution_name,
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    error: formik.touched.institution_name && Boolean(formik.errors.institution_name),
                    helperText: formik.touched.institution_name && formik.errors.institution_name,
                    inputProps: {
                        "aria-label": t("common:Institution_name")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                    fullWidth: true,
                    label: t("register:form.How_many_students_do_you_currently_have"),
                    backgroundColor: "neutral.main",
                    size: "large",
                    name: "student_count",
                    value: formik.values.student_count,
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    error: formik.touched.student_count && Boolean(formik.errors.student_count),
                    helperText: formik.touched.student_count && formik.errors.student_count,
                    inputProps: {
                        "aria-label": t("register:form.students_count")
                    },
                    select: true,
                    children: studentCounts === null || studentCounts === void 0 ? void 0 : studentCounts.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: index,
                            children: type
                        }, index))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                    error: formik.touched.is_register_btn_optional && Boolean(formik.errors.is_register_btn_optional),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "for_client",
                                name: "for_client",
                                checked: formik.values.for_client,
                                onChange: (event)=>formik.setFieldValue("for_client", event.target.checked),
                                inputProps: {
                                    "aria-label": t("register:form.for_client")
                                }
                            }),
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                fontWeight: 400,
                                sx: {
                                    fontSize: {
                                        xs: 13,
                                        md: "inherit"
                                    }
                                },
                                color: "primary.main",
                                children: t("register:form.I_am_setting_up_Blue_assembly_for_a_client")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            children: formik.touched.for_client && formik.errors.for_client
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "flex-end",
                    sx: {
                        mt: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                        id: "info-step1-button",
                        variant: "contained",
                        type: "submit",
                        onClick: formik.handleSubmit,
                        disableElevation: true,
                        "aria-label": t("common:next"),
                        children: t("common:next")
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var components_InfoStep1 = (InfoStep1);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ChevronLeft.js
var ChevronLeft = __webpack_require__(91237);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/outlinedInputClasses.js
var outlinedInputClasses = __webpack_require__(54656);
// EXTERNAL MODULE: ./node_modules/material-ui-phone-number-2/dist/index.js
var dist = __webpack_require__(99248);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./src/components/FlatPhoneNumber/FlatPhoneNumber.js




function FlatPhoneNumber(param) {
    let { label , StartIcon , EndIcon , size ="medium" , backgroundColor , typographyProps , inputProps ={} , ...props } = param;
    const theme = (0,useTheme/* default */.Z)();
    const isSmallScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const responsiveSize = isSmallScreen ? "small" : size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                gutterBottom: true,
                fontSize: responsiveSize,
                sx: {
                    fontSize: responsiveSize
                },
                ...typographyProps,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                sx: {
                    ["& .".concat(outlinedInputClasses/* default.root */.Z.root)]: {
                        backgroundColor
                    }
                },
                inputProps: {
                    style: {
                        direction: "ltr"
                    },
                    ...inputProps
                },
                size: responsiveSize,
                FormHelperTextProps: {
                    sx: {
                        fontSize: responsiveSize
                    }
                },
                ...props
            })
        ]
    });
}
/* harmony default export */ var FlatPhoneNumber_FlatPhoneNumber = (FlatPhoneNumber);

;// CONCATENATED MODULE: ./src/components/FlatPhoneNumber/index.js


/* harmony default export */ var components_FlatPhoneNumber = (FlatPhoneNumber_FlatPhoneNumber);

;// CONCATENATED MODULE: ./src/sections/register/components/InfoStep2.js













const InfoStep2_validationSchema = es/* object */.Ry().shape({
    first_name: es/* string */.Z_().required("Field is required"),
    last_name: es/* string */.Z_().required("Field is required"),
    city: es/* string */.Z_().required("Field is required"),
    country: es/* string */.Z_().required("Field is required"),
    phone: es/* string */.Z_().required("Field is required")
});
function InfoStep2(param) {
    let { data , setData , handleBack , handleNext  } = param;
    var _countryCodeQuery_data, _countriesQuery_data;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "register"
    ]);
    const countryCodeQuery = (0,common/* useGetCountryCode */.o7)();
    var _countryCodeQuery_data_toLowerCase;
    const defaultCountry = (_countryCodeQuery_data_toLowerCase = countryCodeQuery === null || countryCodeQuery === void 0 ? void 0 : (_countryCodeQuery_data = countryCodeQuery.data) === null || _countryCodeQuery_data === void 0 ? void 0 : _countryCodeQuery_data.toLowerCase()) !== null && _countryCodeQuery_data_toLowerCase !== void 0 ? _countryCodeQuery_data_toLowerCase : "sa";
    const createSchoolInfoMutation = (0,common/* useCreateSchoolInfo */.Am)(data.domain, data.token);
    var _data_first_name, _data_last_name, _data_city, _data_country, _data_phone;
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            first_name: (_data_first_name = data === null || data === void 0 ? void 0 : data.first_name) !== null && _data_first_name !== void 0 ? _data_first_name : "",
            last_name: (_data_last_name = data === null || data === void 0 ? void 0 : data.last_name) !== null && _data_last_name !== void 0 ? _data_last_name : "",
            // address: data?.address ?? '',
            city: (_data_city = data === null || data === void 0 ? void 0 : data.city) !== null && _data_city !== void 0 ? _data_city : "",
            country: (_data_country = data === null || data === void 0 ? void 0 : data.country) !== null && _data_country !== void 0 ? _data_country : defaultCountry,
            phone: (_data_phone = data === null || data === void 0 ? void 0 : data.phone) !== null && _data_phone !== void 0 ? _data_phone : ""
        },
        validationSchema: InfoStep2_validationSchema,
        enableReinitialize: true,
        onSubmit: (values, actions)=>{
            setData((prevData)=>({
                    ...prevData,
                    ...values
                }));
            createSchoolInfoMutation.mutateAsync({
                ...data,
                ...values
            }).then(()=>handleNext()).catch(()=>react_toastify_esm/* toast.error */.Am.error("failed to create data")).finally(()=>actions.setSubmitting(false));
            actions.setSubmitting(false);
        }
    });
    const countriesQuery = (0,common/* useCountries */.FE)(data.domain, data.token);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
            xs: 2,
            md: 5
        },
        onSubmit: formik.handleSubmit,
        component: "form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                md: 6,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                    fullWidth: true,
                    label: t("register:form.First_name"),
                    backgroundColor: "neutral.main",
                    size: "large",
                    name: "first_name",
                    value: formik.values.first_name,
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    error: formik.touched.first_name && Boolean(formik.errors.first_name),
                    helperText: formik.touched.first_name && formik.errors.first_name,
                    inputProps: {
                        "aria-label": t("register:form.First_name")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                md: 6,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                    fullWidth: true,
                    label: t("register:form.Last_name"),
                    backgroundColor: "neutral.main",
                    size: "large",
                    name: "last_name",
                    value: formik.values.last_name,
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    error: formik.touched.last_name && Boolean(formik.errors.last_name),
                    helperText: formik.touched.last_name && formik.errors.last_name,
                    inputProps: {
                        "aria-label": t("register:form.Last_name")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                md: 6,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                    fullWidth: true,
                    label: t("register:form.Country"),
                    backgroundColor: "neutral.main",
                    size: "large",
                    name: "country",
                    value: formik.values.country,
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    error: formik.touched.country && Boolean(formik.errors.country),
                    helperText: formik.touched.country && formik.errors.country,
                    inputProps: {
                        "aria-label": t("register:form.Country")
                    },
                    select: true,
                    children: (_countriesQuery_data = countriesQuery.data) === null || _countriesQuery_data === void 0 ? void 0 : _countriesQuery_data.map((country)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: country.name,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            width: "20",
                                            src: "https://flagcdn.com/w20/".concat(country.code.toLowerCase(), ".png"),
                                            srcSet: "https://flagcdn.com/w40/".concat(country.code.toLowerCase(), ".png 2x"),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        children: country.name
                                    })
                                ]
                            })
                        }, country.name))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                md: 6,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                    fullWidth: true,
                    label: t("register:form.City"),
                    backgroundColor: "neutral.main",
                    size: "large",
                    name: "city",
                    value: formik.values.city,
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    error: formik.touched.city && Boolean(formik.errors.city),
                    helperText: formik.touched.city && formik.errors.city,
                    inputProps: {
                        "aria-label": t("register:form.City")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FlatPhoneNumber, {
                    defaultCountry: defaultCountry,
                    disableAreaCodes: true,
                    fullWidth: true,
                    label: t("register:form.Phone_number"),
                    variant: "outlined",
                    backgroundColor: "neutral.main",
                    name: "phone",
                    value: formik.values.phone,
                    onChange: (value)=>formik.setFieldValue("phone", value),
                    onBlur: formik.handleBlur,
                    error: formik.touched.phone && Boolean(formik.errors.phone),
                    helperText: formik.touched.phone && formik.errors.phone,
                    inputProps: {
                        "aria-label": t("register:form.Phone_number")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "space-between",
                    sx: {
                        mt: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                            color: "neutral",
                            sx: {
                                color: "neutral.dark"
                            },
                            onClick: handleBack,
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {}),
                            "aria-label": t("common:back"),
                            children: t("common:back")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatButton/* default */.Z, {
                            id: "info-step3-button",
                            variant: "contained",
                            type: "submit",
                            onClick: formik.handleSubmit,
                            disableElevation: true,
                            "aria-label": t("common:submit"),
                            isLoading: formik.isSubmitting,
                            children: t("common:submit")
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var components_InfoStep2 = (InfoStep2);

// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 3 modules
var Radio = __webpack_require__(45993);
;// CONCATENATED MODULE: ./src/sections/register/components/InfoSchoolStructure.js











const InfoSchoolStructure_validationSchema = es/* object */.Ry().shape({
    branches_count: es/* number */.Rx().integer().min(1).required("Field is required"),
    levels: es/* array */.IX().min(1).required("Field is required"),
    education_system: es/* string */.Z_().required("Field is required")
});
function InfoSchoolStructure(param) {
    let { data , setData , handleBack , handleNext  } = param;
    var _schoolInfoQuery_data, _schoolInfoQuery_data_levels, _schoolInfoQuery_data1, _schoolInfoQuery_data_educational_system;
    const { t , i18n  } = (0,esm/* useTranslation */.$G)([
        "common",
        "register"
    ]);
    var _data_branches_count, _data_levels, _data_education_system;
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            branches_count: (_data_branches_count = data === null || data === void 0 ? void 0 : data.branches_count) !== null && _data_branches_count !== void 0 ? _data_branches_count : "",
            levels: (_data_levels = data === null || data === void 0 ? void 0 : data.levels) !== null && _data_levels !== void 0 ? _data_levels : [],
            education_system: (_data_education_system = data === null || data === void 0 ? void 0 : data.education_system) !== null && _data_education_system !== void 0 ? _data_education_system : ""
        },
        validationSchema: InfoSchoolStructure_validationSchema,
        enableReinitialize: true,
        onSubmit: (values, actions)=>{
            setData((prevData)=>({
                    ...prevData,
                    ...values
                }));
            handleNext();
            actions.setSubmitting(false);
        }
    });
    const schoolInfoQuery = (0,common/* useSchoolInfo */.Kh)(data.domain, data.token, i18n.language);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: {
            xs: 2,
            md: 5
        },
        onSubmit: formik.handleSubmit,
        component: "form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                    fullWidth: true,
                    label: t("register:form.How_many_branches_do_you_have_for_your_school"),
                    backgroundColor: "neutral.main",
                    size: "large",
                    type: "number",
                    name: "branches_count",
                    value: formik.values.branches_count,
                    onChange: formik.handleChange,
                    onBlur: formik.handleBlur,
                    error: formik.touched.branches_count && Boolean(formik.errors.branches_count),
                    helperText: formik.touched.branches_count && formik.errors.branches_count,
                    inputProps: {
                        "aria-label": t("register:form.How_many_branches_do_you_have_for_your_school")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                    error: formik.touched.levels && Boolean(formik.errors.levels),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            gutterBottom: true,
                            display: "block",
                            sx: {
                                fontSize: {
                                    xs: 13,
                                    sm: "inherit"
                                }
                            },
                            children: t("register:form.What_are_the_levels_in_your_school")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 0,
                            children: (_schoolInfoQuery_data = schoolInfoQuery.data) === null || _schoolInfoQuery_data === void 0 ? void 0 : (_schoolInfoQuery_data_levels = _schoolInfoQuery_data.levels) === null || _schoolInfoQuery_data_levels === void 0 ? void 0 : _schoolInfoQuery_data_levels.map((label, index)=>{
                                var _formik_values_levels;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            id: label,
                                            name: index,
                                            checked: (_formik_values_levels = formik.values.levels) === null || _formik_values_levels === void 0 ? void 0 : _formik_values_levels.some((value)=>value === index),
                                            onChange: (event)=>{
                                                const { checked  } = event.target;
                                                if (checked) formik.setFieldValue("levels", [
                                                    ...formik.values.levels,
                                                    index
                                                ]);
                                                else formik.setFieldValue("levels", formik.values.levels.filter((value)=>value !== index));
                                            },
                                            inputProps: {
                                                "aria-label": label
                                            }
                                        }),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            fontWeight: 400,
                                            sx: {
                                                fontSize: {
                                                    xs: 13,
                                                    md: "inherit"
                                                }
                                            },
                                            color: "neutral.dark",
                                            children: label
                                        })
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            children: formik.touched.levels && formik.errors.levels
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                    error: formik.touched.education_system && Boolean(formik.errors.education_system),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            gutterBottom: true,
                            display: "block",
                            sx: {
                                fontSize: {
                                    xs: 13,
                                    sm: "inherit"
                                }
                            },
                            children: t("register:form.What_is_the_most_education_system_similar_to_your_school_system")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 0,
                            children: (_schoolInfoQuery_data1 = schoolInfoQuery.data) === null || _schoolInfoQuery_data1 === void 0 ? void 0 : (_schoolInfoQuery_data_educational_system = _schoolInfoQuery_data1.educational_system) === null || _schoolInfoQuery_data_educational_system === void 0 ? void 0 : _schoolInfoQuery_data_educational_system.map((label, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            className: "education_system",
                                            name: "education_system",
                                            checked: formik.values.education_system === index,
                                            onChange: ()=>formik.setFieldValue("education_system", index),
                                            inputProps: {
                                                "aria-label": label
                                            }
                                        }),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            fontWeight: 400,
                                            sx: {
                                                fontSize: {
                                                    xs: 13,
                                                    md: "inherit"
                                                }
                                            },
                                            color: "neutral.dark",
                                            children: label
                                        })
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            children: formik.touched.education_system && formik.errors.education_system
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "space-between",
                    sx: {
                        mt: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                            color: "neutral",
                            sx: {
                                color: "neutral.dark"
                            },
                            onClick: handleBack,
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {}),
                            "aria-label": t("common:back"),
                            children: t("common:back")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatButton/* default */.Z, {
                            id: "info-step2-button",
                            variant: "contained",
                            type: "submit",
                            onClick: formik.handleSubmit,
                            disableElevation: true,
                            "aria-label": t("common:submit"),
                            children: t("common:next")
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var components_InfoSchoolStructure = (InfoSchoolStructure);

;// CONCATENATED MODULE: ./src/sections/register/components/AccountInfoSection.js







const steps = [
    {
        header: "Just_3_steps_away_from_creating_your_site",
        title: "about_your_institution",
        Component: components_InfoStep1
    },
    {
        header: "Just_2_steps_away_from_creating_your_site",
        title: "your_school_structure",
        Component: components_InfoSchoolStructure
    },
    {
        header: "One_last_step_to_create_your_site",
        title: "personal_info",
        Component: components_InfoStep2
    }
];
function AccountInfoSection(param) {
    let { data , setData , handleBack , handleNext  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [active, setActive] = react.useState(0);
    const next = ()=>{
        if (active < steps.length - 1) setActive(active + 1);
        else handleNext();
    };
    const back = ()=>{
        if (active > 0) setActive(active - 1);
        else handleBack();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        pb: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 3,
                    sx: {
                        backgroundColor: "primary.main",
                        color: "primary.contrastText"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        display: "block",
                        textAlign: "center",
                        children: t("register:account_info.".concat(steps[active].header))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                    sx: {
                        borderRadius: 4,
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        py: {
                            xs: 4,
                            md: 5
                        },
                        px: {
                            xs: 3,
                            md: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
                                activeStep: active,
                                alternativeLabel: true,
                                children: steps.map((param, index)=>/*#__PURE__*/ {
                                    let { title  } = param;
                                    return (0,jsx_runtime.jsx)(Step/* default */.Z, {
                                        sx: {
                                            ".MuiStepConnector-root": {
                                                top: "25px",
                                                left: "calc(-50% + 25px)",
                                                right: "calc(50% + 25px)"
                                            },
                                            ".MuiStepIcon-text": {
                                                fontFamily: "var(--cairo-font)",
                                                fill: (theme)=>active === index ? theme.palette.primary.main : "white",
                                                fontSize: 12,
                                                color: "white !important"
                                            },
                                            ".MuiStepLabel-label": {
                                                fontSize: {
                                                    xs: 13,
                                                    sm: 17
                                                }
                                            },
                                            ".MuiSvgIcon-root": {
                                                transform: "scaleX(1) !important",
                                                border: "2px solid",
                                                borderColor: active === index ? "primary.main" : "transparent",
                                                color: // eslint-disable-next-line no-nested-ternary
                                                active === index ? "white !important" : active > index ? "primary.main" : "#C4C4C4",
                                                borderRadius: "50%"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepLabel/* default */.Z, {
                                            color: "primary.main",
                                            StepIconProps: {
                                                sx: {
                                                    fontFamily: "Cairo !important",
                                                    fontSize: 50
                                                }
                                            },
                                            sx: {
                                                textTransform: "capitalize"
                                            },
                                            children: t("register:account_info.".concat(title))
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 6,
                                children: steps.map((param, index)=>/*#__PURE__*/ {
                                    let { Component  } = param;
                                    return (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                        in: active === index,
                                        sx: {
                                            display: active === index ? "" : "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                                handleNext: next,
                                                handleBack: back,
                                                data: data,
                                                setData: setData
                                            })
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_AccountInfoSection = (AccountInfoSection);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/api/domain.js
var domain = __webpack_require__(13124);
;// CONCATENATED MODULE: ./src/sections/register/components/LoadingSection.js





function LoadingSection(param) {
    let { active , data  } = param;
    const { locale  } = (0,router.useRouter)();
    const handleFinish = ()=>{
        window.location.href = "https://".concat(data.domain, ".blueassembly.com/admin/").concat(locale, "/login?token=").concat(data.token);
    };
    const domainStatusQuery = (0,domain/* useMonitDomainStatus */.r)(data.domain, active);
    react.useEffect(()=>{
        var _domainStatusQuery_data;
        if (((_domainStatusQuery_data = domainStatusQuery.data) === null || _domainStatusQuery_data === void 0 ? void 0 : _domainStatusQuery_data.status) === "ready") handleFinish();
        return ()=>domainStatusQuery.remove();
    }, [
        domainStatusQuery.data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader, {
        active: active
    });
}
/* harmony default export */ var components_LoadingSection = (LoadingSection);

;// CONCATENATED MODULE: ./src/sections/register/RegisterSection.js










function RegisterSection() {
    const [active, setActive] = react.useState("instructions");
    const [data, setData] = react.useState({});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            position: "relative",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            flexDirection: "column",
            sx: {
                minHeight: "100vh"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                width: "100%",
                                display: {
                                    xs: "none",
                                    md: "block"
                                },
                                zIndex: -1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(register_drawings/* default */.Z, {
                                width: "100%",
                                height: "100%"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                width: "100%",
                                display: {
                                    xs: "block",
                                    md: "none"
                                },
                                zIndex: -1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(register_drawings_small/* default */.Z, {
                                width: "100%",
                                height: "100%"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            in: active === "instructions",
                            sx: {
                                display: active === "instructions" ? "" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InstructionsSection, {
                                    handleSkip: ()=>setActive("register")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            in: active === "register",
                            sx: {
                                display: active === "register" ? "" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateAccountSection, {
                                    handleBack: ()=>setActive("register"),
                                    handleNext: ()=>setActive("post-register"),
                                    data: data,
                                    setData: setData
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            in: active === "post-register",
                            sx: {
                                display: active === "post-register" ? "" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AccountInfoSection, {
                                    handleNext: ()=>setActive("pending"),
                                    data: data,
                                    setData: setData
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            in: active === "pending",
                            sx: {
                                display: active === "pending" ? "" : "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LoadingSection, {
                                    active: active === "pending",
                                    data: data
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    flexGrow: 1,
                    justifyContent: "center",
                    alignItems: "flex-end",
                    container: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        sx: {
                            my: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelect/* default */.Z, {})
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var register_RegisterSection = ((/* unused pure expression or super */ null && (RegisterSection)));

;// CONCATENATED MODULE: ./src/sections/register/index.js


// EXTERNAL MODULE: ./src/contexts/CaptchaProvider/index.js + 1 modules
var CaptchaProvider = __webpack_require__(28248);
;// CONCATENATED MODULE: ./pages/register.js






function Register() {
    const { t  } = (0,esm/* useTranslation */.$G)([
        "meta"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaptchaProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: "".concat(t("meta:register.title"), " - Blue Assembly")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: t("meta:register.description")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterSection, {})
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ var register = ((0,esm/* withTranslation */.Zh)([
    "common"
])(Register));


/***/ }),

/***/ 90176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ useCreateSchoolInfo; },
/* harmony export */   "FE": function() { return /* binding */ useCountries; },
/* harmony export */   "IF": function() { return /* binding */ useCreateContactUs; },
/* harmony export */   "Kh": function() { return /* binding */ useSchoolInfo; },
/* harmony export */   "o7": function() { return /* binding */ useGetCountryCode; }
/* harmony export */ });
/* unused harmony exports KEYS, getCountries, getSchoolInfo */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85945);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48228);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70594);
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16799);



const KEYS = {
    COUNTRIES: "countries",
    SCHOOL_INFO: "school-info",
    GEOLOCATION: "geolocation"
};
const getCountries = async (tenant, token)=>{
    const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/countries", {
        headers: {
            subdomain: tenant,
            authorization: "Bearer ".concat(token)
        }
    });
    return response.data.data;
};
const useCountries = (tenant, token)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        KEYS.COUNTRIES,
        tenant
    ], async ()=>getCountries(tenant, token), {
        enabled: Boolean(tenant && token)
    });
const getSchoolInfo = async (tenant, token)=>{
    const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/school/info", {
        headers: {
            subdomain: tenant,
            authorization: "Bearer ".concat(token)
        }
    });
    return response.data.data;
};
const useSchoolInfo = function(tenant, token) {
    let locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en";
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        KEYS.SCHOOL_INFO,
        tenant,
        "locale=".concat(locale)
    ], async ()=>getSchoolInfo(tenant, token), {
        enabled: Boolean(tenant && token)
    });
};
const useGetCountryCode = ()=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        KEYS.GEOLOCATION
    ], async ()=>{
        const response = await axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("https://api.db-ip.com/v2/free/self");
        return response.data.countryCode;
    }, {
        staleTime: Infinity
    });
const useCreateSchoolInfo = (tenant, token)=>{
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D)((payload)=>_httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.post */ .M.post("/school/info", payload, {
            headers: {
                subdomain: tenant,
                authorization: "Bearer ".concat(token)
            }
        }), {
        onSuccess: ()=>{
            queryClient.invalidateQueries(KEYS.SCHOOL_INFO);
        }
    });
};
const useCreateContactUs = ()=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D)((payload)=>_httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.post */ .M.post("/contact-us", payload));


/***/ }),

/***/ 13124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useVerifyDomain; },
/* harmony export */   "r": function() { return /* binding */ useMonitDomainStatus; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48228);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67848);
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16799);


const useVerifyDomain = ()=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D)((payload)=>_httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/auth/domain_validation", {
            params: payload
        }));
const useMonitDomainStatus = (domain, enabled)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "domain-status"
    ], async ()=>{
        const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/tenant/status/".concat(domain));
        return response.data.data;
    }, {
        refetchInterval: 5000,
        enabled
    });


/***/ }),

/***/ 42641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22283);

function getLocalizeImage(path) {
    return "/images/".concat(next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n.language */ .ag.language, "/").concat(path);
}
/* harmony default export */ __webpack_exports__["Z"] = (getLocalizeImage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6,88,296,809,718,558,367,984,616,80,480,894,774,888,179], function() { return __webpack_exec__(75511); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);